import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useUserSelectedRoleList = () => {
  const [selectedRoleListLoading, setSelectedRoleListLoading] = useState(true);
  const [selectedRoleList, setSelectedRoleList] = useState([]);
  const [pageRef, setPageRef] = useState(null);
  const { enqueueSnackbar } = useSnackbar();

  const getSelectedRoleList = ({ Guid, Page, Count }) => {
    setSelectedRoleListLoading(true);

    axiosClient
      .get('SettingAccount/User/Role/SelectedList', {
        params: { Guid, Page, Count },
      })
      .then(res => {
        if (res.status === 200) {
          setPageRef(res.data.value);
          setSelectedRoleList(
            res.data.value.list.map(role => ({
              id: role.roleGuid,
              display: role.display,
              selected: role.selected,
            })),
          );
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setSelectedRoleListLoading(false));
  };

  return {
    getSelectedRoleList,
    selectedRoleListLoading,
    selectedRoleList,
    pageRef,
  };
};

export default useUserSelectedRoleList;
